import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Address } from "ngx-google-places-autocomplete/objects/address";

import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { VehiclesService } from "../../vehicles/vehicles.service";
import { PostLoadService } from "./post-load.service";
import { Router } from "@angular/router";
@Component({
  selector: "app-post-load",
  templateUrl: "./post-load.component.html",
  styleUrls: ["./post-load.component.sass"],
})
export class PostLoadComponent implements OnInit {
  loadForm!: FormGroup;
  // Restrict autocomplete to cities in India (optional)
  placesOptions = {
    types: ["(cities)"],
    componentRestrictions: { country: "in" },
  };

  truckTypes: any[] = [];
  availableTons: any[] = [];
  allTyres: any[] = [];
  advancePercentages: number[] = [];
  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private vehiclesService: VehiclesService,
    private postLoadService: PostLoadService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.getAllVehicle();
    this.getAllTruckTyres();

    this.advancePercentages = Array.from(
      { length: 10 },
      (_, i) => (i + 1) * 10
    );

    // this.loadForm = this.fb.group({
    //   pickupDate: [""],
    //   deliveryDate: [""],

    //   pickupLocationCity: [""],
    //   pickupLocationState: [""],
    //   pickupLocationCountry: [""],
    //   pickupLatitude: [""],
    //   pickupLongitude: [""],

    //   dropLocationCity: [""],
    //   dropLocationState: [""],
    //   dropLocationCountry: [""],
    //   dropLatitude: [""],
    //   dropLongitude: [""],

    //   vehicleId: [""],
    //   vehicleType: [""],
    //   vehicleTonsId: [""],
    //   vehicleQuantity: [1],
    //   vehicleCapacityType: [null, Validators.required],
    //   vehicleTyres: [""],
    //   vehicleCapacity: [0],
    //   availableWeight: [0],
    //   length: [0],
    //   breathe: [0],
    //   height: [0],

    //   product: [""],
    //   productType: [""],
    //   productWeight: [0],

    //   paymentTerms: ["To Pay"],
    //   amount: [0],
    //   advance: [""],

    //   specialInstructions: [""],
    // });

    this.loadForm = this.fb.group({
      // Pickup & Delivery
      pickupLocation: ["", Validators.required], // 👈 bind Places input
      dropLocation: ["", Validators.required], // 👈 bind Places input
      // pickupDate: ["", Validators.required],
      // deliveryDate: ["", Validators.required],

      // Required so user must choose a suggestion (gets set on selection)
      pickupLatitude: [null, Validators.required],
      pickupLongitude: [null, Validators.required],
      dropLatitude: [null, Validators.required],
      dropLongitude: [null, Validators.required],

      // Optional: keep these if you need them
      pickupLocationCity: [""],
      pickupLocationState: [""],
      pickupLocationCountry: [""],
      dropLocationCity: [""],
      dropLocationState: [""],
      dropLocationCountry: [""],

      // Vehicle
      vehicleId: ["", Validators.required],
      vehicleTonsId: ["", Validators.required],
      vehicleTyres: ["", Validators.required],
      vehicleCapacityType: [null, Validators.required],
      length: [""],
      breathe: [""],
      height: [""],

      // Product
      product: ["", [Validators.required, Validators.minLength(2)]],
      productType: ["", Validators.required],
      productWeight: ["", [Validators.required, Validators.min(1)]],

      // Payment
      amount: ["", [Validators.required, Validators.min(1)]],
      advance: ["", Validators.required],

      // Other
      specialInstructions: [""],
    });

    this.loadForm
      .get("vehicleCapacityType")
      ?.valueChanges.subscribe((value) => {
        if (value === "2" || value === 2) {
          // check both string and number
          this.loadForm
            .get("length")
            ?.setValidators([Validators.required, Validators.min(1)]);
          this.loadForm
            .get("breathe")
            ?.setValidators([Validators.required, Validators.min(1)]);
          this.loadForm
            .get("height")
            ?.setValidators([Validators.required, Validators.min(1)]);
        } else {
          this.loadForm.get("length")?.clearValidators();
          this.loadForm.get("breathe")?.clearValidators();
          this.loadForm.get("height")?.clearValidators();
        }

        this.loadForm.get("length")?.updateValueAndValidity();
        this.loadForm.get("breathe")?.updateValueAndValidity();
        this.loadForm.get("height")?.updateValueAndValidity();
      });
  }

  // Handle Pickup Address
  // handlePickupAddress(address: Address) {
  //   const components = this.getAddressComponents(address);
  //   this.loadForm.patchValue({
  //     pickupLocationCity: components.city,
  //     pickupLocationState: components.state,
  //     pickupLocationCountry: components.country,
  //     pickupLatitude: address.geometry.location.lat(),
  //     pickupLongitude: address.geometry.location.lng(),
  //   });
  // }

  // // Handle Drop Address
  // handleDropAddress(address: Address) {
  //   const components = this.getAddressComponents(address);
  //   this.loadForm.patchValue({
  //     dropLocationCity: components.city,
  //     dropLocationState: components.state,
  //     dropLocationCountry: components.country,
  //     dropLatitude: address.geometry.location.lat(),
  //     dropLongitude: address.geometry.location.lng(),
  //   });
  // }

  handlePickupAddress(address: Address) {
    const c = this.getAddressComponents(address);
    this.loadForm.patchValue({
      pickupLocation: address.formatted_address || address.name || "",
      pickupLocationCity: c.city,
      pickupLocationState: c.state,
      pickupLocationCountry: c.country,
      pickupLatitude: address.geometry?.location?.lat() ?? null,
      pickupLongitude: address.geometry?.location?.lng() ?? null,
    });
    this.loadForm.get("pickupLatitude")?.updateValueAndValidity();
    this.loadForm.get("pickupLongitude")?.updateValueAndValidity();
  }

  handleDropAddress(address: Address) {
    const c = this.getAddressComponents(address);
    this.loadForm.patchValue({
      dropLocation: address.formatted_address || address.name || "",
      dropLocationCity: c.city,
      dropLocationState: c.state,
      dropLocationCountry: c.country,
      dropLatitude: address.geometry?.location?.lat() ?? null,
      dropLongitude: address.geometry?.location?.lng() ?? null,
    });
    this.loadForm.get("dropLatitude")?.updateValueAndValidity();
    this.loadForm.get("dropLongitude")?.updateValueAndValidity();
  }

  // If the user starts typing after selecting, clear derived fields so form becomes invalid again.
  onPickupTyping() {
    this.loadForm.patchValue({
      pickupLatitude: null,
      pickupLongitude: null,
      pickupLocationCity: "",
      pickupLocationState: "",
      pickupLocationCountry: "",
    });
    this.loadForm.get("pickupLatitude")?.updateValueAndValidity();
    this.loadForm.get("pickupLongitude")?.updateValueAndValidity();
  }

  onDropTyping() {
    this.loadForm.patchValue({
      dropLatitude: null,
      dropLongitude: null,
      dropLocationCity: "",
      dropLocationState: "",
      dropLocationCountry: "",
    });
    this.loadForm.get("dropLatitude")?.updateValueAndValidity();
    this.loadForm.get("dropLongitude")?.updateValueAndValidity();
  }

  // Utility: Extract City/State/Country
  private getAddressComponents(place: any) {
    let city = "";
    let state = "";
    let country = "";
    for (const component of place.address_components) {
      if (component.types.includes("locality")) {
        city = component.long_name;
      }
      if (component.types.includes("administrative_area_level_1")) {
        state = component.long_name;
      }
      if (component.types.includes("country")) {
        country = component.long_name;
      }
    }
    return { city, state, country };
  }

  getAllVehicle() {
    this.spinner.show();
    let data = {
      isActive: 1,
    };
    this.vehiclesService.getAllVehicle(data).subscribe((result: any) => {
      if (result.statusCode == 200) {
        // console.log("get all vehicles ", result);
        this.truckTypes = result.data;
        this.spinner.hide();
      } else {
        this.spinner.hide();
        this.toastr.error(result.message);
      }
    });
  }

  onVehicleChange(event: any) {
    const selectedId = event.target.value;
    const selectedTruck = this.truckTypes.find((t) => t._id === selectedId);

    if (selectedTruck) {
      // Update both form controls
      this.getTruckTons(selectedTruck._id);
      this.loadForm.patchValue({
        vehicleId: selectedTruck._id,
        vehicleType: selectedTruck.truckType,
      });
    }
  }

  getTruckTons(truckId) {
    this.spinner.show();
    let data = { truckId: truckId };

    this.vehiclesService.getTruckTons(data).subscribe((result: any) => {
      if (result.statusCode == 200) {
        this.availableTons = result.data;
        this.spinner.hide();
      } else {
        this.spinner.hide();
        this.toastr.error(result.message);
      }
    });
  }

  getAllTruckTyres() {
    this.spinner.show();
    let data = {
      isActive: 1,
    };
    this.vehiclesService.getTyres(data).subscribe((result: any) => {
      if (result.statusCode == 200) {
        // console.log("get all vehicles ", result);
        this.allTyres = result.data;
        this.spinner.hide();
      } else {
        this.spinner.hide();
        this.toastr.error(result.message);
      }
    });
  }

  // post load api called here
  onSubmit() {
    if (this.loadForm.invalid) {
      this.loadForm.markAllAsTouched();
      return;
    }
    console.log(this.loadForm.value);
    let data = {
      pickupLocationCity: this.loadForm.value.pickupLocationCity,
      pickupLocationState: this.loadForm.value.pickupLocationState,
      pickupLocationCountry: this.loadForm.value.pickupLocationCountry,

      dropLocationCity: this.loadForm.value.dropLocationCity,
      dropLocationState: this.loadForm.value.dropLocationState,
      dropLocationCountry: this.loadForm.value.dropLocationCountry,

      vehicleId: this.loadForm.value.vehicleId,
      vehicleTonsId: this.loadForm.value.vehicleTonsId,
      vehicleTyres: Number(this.loadForm.value.vehicleTyres),

      productType: this.loadForm.value.productType,
      product: this.loadForm.value.product,
      productWeight: this.loadForm.value.productWeight,

      pickupLatitude: this.loadForm.value.pickupLatitude,
      pickupLongitude: this.loadForm.value.pickupLongitude,
      dropLatitude: this.loadForm.value.dropLatitude,
      dropLongitude: this.loadForm.value.dropLongitude,

      vehicleCapacityType: this.loadForm.value.vehicleCapacityType,
      availableWeight: this.loadForm.value.availableWeight,
      length: Number(this.loadForm.value.length),
      breathe: Number(this.loadForm.value.breathe),
      height: Number(this.loadForm.value.height),

      amount: Number(this.loadForm.value.amount),
      advance: Number(this.loadForm.value.advance),

      specialInstructions: this.loadForm.value.specialInstructions,

    };
    this.postLoadService.postLoad(data).subscribe((result: any) => {
      if (result.statusCode == 200) {
        this.toastr.success(result.message);
        this.spinner.hide();
        this.loadForm.reset();
      } else {
        this.spinner.hide();
        this.toastr.error(result.message);
      }
    });
    console.log("reqData", data);
  }
}
